import type { Nullable } from 'corgi-types';

import { SectionName } from './enums';
import type {
  ImageSectionDataProps,
  ImageSectionItem,
  LinkSectionDataProps,
  LinkSectionItem,
} from './types';

export interface GetSectionParams {
  help?: Nullable<LinkSectionDataProps>;
  shipping?: Nullable<ImageSectionDataProps>;
  payment?: Nullable<ImageSectionDataProps>;
  social?: Nullable<ImageSectionDataProps>;
  international?: Nullable<ImageSectionDataProps>;
  general?: Nullable<LinkSectionDataProps>;
}

export interface LinkSection {
  key: SectionName;
  data: LinkSectionDataProps;
  width: Array<Nullable<number>>;
}

const PRIMARY_SECTION_SIZE = [1, null, 1 / 2];
const SECONDARY_SECTION_SIZE = [1, null, 1 / 4];

export const getSections = ({
  general,
  help,
  payment,
  international,
  shipping,
  social,
}: GetSectionParams) =>
  [
    { key: SectionName.General, data: general, width: PRIMARY_SECTION_SIZE },
    { key: SectionName.Help, data: help, width: PRIMARY_SECTION_SIZE },
    {
      key: SectionName.Payment,
      data: payment,
      width: SECONDARY_SECTION_SIZE,
    },
    {
      key: SectionName.Shipping,
      data: shipping,
      width: SECONDARY_SECTION_SIZE,
    },
    {
      key: SectionName.International,
      data: international,
      width: SECONDARY_SECTION_SIZE,
    },
    { key: SectionName.Social, data: social, width: SECONDARY_SECTION_SIZE },
  ].filter((linkSection): linkSection is LinkSection => !!linkSection.data);

type GeneralOnlySections = [
  {
    key: SectionName.General;
    data: LinkSectionDataProps;
    width: Array<Nullable<number>>;
  },
];

export const isGeneralOnly = (sections: LinkSection[]): sections is GeneralOnlySections =>
  sections.length === 1 && sections[0].key === SectionName.General;

export const hasImage = (item: LinkSectionItem | ImageSectionItem): item is ImageSectionItem =>
  'image' in item && !!item.image;
